// Asset URL configuration for different environments
const getAssetUrl = (path: string): string => {
  // Remove leading slash if present
  const cleanPath = path.startsWith('/') ? path.slice(1) : path

  // In production, use S3 bucket URL
  if ((import.meta as any).env.PROD) {
    return `https://core-briefing-production-assets.s3.amazonaws.com/${cleanPath}`
  }
  
  // In development, use local public folder
  return `/${cleanPath}`
}

// Asset paths
export const ASSETS = {
  // Logos
  LOGO_CORE: getAssetUrl('assets/logos/core-logo-new.png'),
  LOGO_COALBOT: getAssetUrl('assets/logos/coalbot-logo.png'),
  LOGO_CORE_BRIEFING: getAssetUrl('assets/logos/the-core-briefing-logo.png'),
} as const

export default ASSETS 